const animateInTransitionProps = {
  initial: { translateY: 50, opacity: 0 },
  animate: { translateY: 0, opacity: 1 },
  exit: { translateY: -50 },
  transition: { duration: 0.3 },
};

export default animateInTransitionProps;
